//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fillMeta } from '~/utils/seo';
import SignupRequest from '~/api/requests/auth/signup';
import UserMethods from '~/api/methods/auth';

export default {
  name: 'signup',
  platforms: ['CABINET'],
  access: '*',
  head () {
    return fillMeta({ title: this.title });
  },
  data () {
    return {
      request: new SignupRequest(),
      sender: new UserMethods(),
      submitPending: false,
      error: null,
    };
  },
  computed: {
    title () {
      return this.$t(`signup.title`);
    },
  },
  methods: {
    signup () {
      if (this.submitPending) return;
      const errors = this.$refs.form.validate();
      if (errors) return;
      this.submitPending = true;
      this.sender.signup(this.request)
        .then(() => {
          this.$router.push({
            name: 'login',
            query: this.$route.query,
          });
        })
        .catch(err => {
          this.handleErrors(err);
          this.submitPending = false;
          return Promise.reject(err);
        });
    },
  },
};
